import './Card.css';

/**
 * Card — gabarit standard (charte) : corps blanc arrondi + en-tête blanc à filet.
 *
 * En-tête = surface blanche + filet bas (label en petites capitales atténué),
 * titre à gauche, actions/filtre à droite. Standardise le pattern
 * historiquement codé en dur dans CostAssignmentPage (.tcp-card).
 *
 * Props :
 *   title    : string | node   — titre dans le bandeau (optionnel)
 *   subtitle : string | node   — ligne fine sous le titre (optionnel)
 *   actions  : node            — filtre/boutons alignés à droite du bandeau
 *   flush    : bool            — corps sans padding (tables pleine largeur)
 *   className/bodyClassName    — classes additionnelles
 */
export default function Card({
  title,
  subtitle,
  actions,
  flush = false,
  children,
  className = '',
  bodyClassName = '',
}) {
  const hasHead = title != null || actions != null;
  return (
    <section className={`std-card${className ? ' ' + className : ''}`}>
      {hasHead && (
        <div className="std-card__head">
          <div className="std-card__head-text">
            {title != null && <p className="std-card__title">{title}</p>}
            {subtitle != null && <p className="std-card__subtitle">{subtitle}</p>}
          </div>
          {actions != null && <div className="std-card__actions">{actions}</div>}
        </div>
      )}
      <div className={`std-card__body${flush ? ' std-card__body--flush' : ''}${bodyClassName ? ' ' + bodyClassName : ''}`}>
        {children}
      </div>
    </section>
  );
}
